var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    _setup.getComponent.component,
    _vm._b(
      {
        tag: "component",
        class: ["soli-round"],
        attrs: { "content-class": "soli-round" },
        on: {
          "click:outside": function ($event) {
            return _setup.reset()
          },
        },
        model: {
          value: _setup.show,
          callback: function ($$v) {
            _setup.show = $$v
          },
          expression: "show",
        },
      },
      "component",
      { ..._setup.getComponent.props },
      false
    ),
    [
      _c(
        "v-form",
        {
          ref: "form",
          on: {
            submit: function ($event) {
              $event.preventDefault()
              return _setup.process()
            },
          },
          model: {
            value: _setup.valid,
            callback: function ($$v) {
              _setup.valid = $$v
            },
            expression: "valid",
          },
        },
        [
          _c(
            "v-card",
            {
              staticClass:
                "simple-form half-round safe-bottom overflow-auto soli-grey",
              attrs: { flat: "", "max-height": "90vh" },
            },
            [
              _c(
                "v-btn",
                {
                  staticClass: "modal-close-btn",
                  attrs: { icon: "", color: "dark" },
                  on: {
                    click: function ($event) {
                      return _setup.reset()
                    },
                  },
                },
                [_c("v-icon", [_vm._v("clear")])],
                1
              ),
              _vm._v(" "),
              _c(
                "v-container",
                { staticClass: "py-0" },
                [
                  _c("v-card-title", [_vm._v(_vm._s(_vm.title))]),
                  _vm._v(" "),
                  _c("v-card-subtitle", { staticClass: "pt-4" }, [
                    _vm._v(_vm._s(_vm.subtitle)),
                  ]),
                  _vm._v(" "),
                  _c("v-card-text", [_vm._t("body")], 2),
                ],
                1
              ),
              _vm._v(" "),
              _c("v-divider"),
              _vm._v(" "),
              _c(
                "v-card-actions",
                { staticClass: "justify-end" },
                [
                  _c(
                    "v-btn",
                    {
                      attrs: { text: "", rounded: "", color: "dark" },
                      on: {
                        click: function ($event) {
                          return _setup.reset()
                        },
                      },
                    },
                    [_vm._v("\n                    Cancel\n                ")]
                  ),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      attrs: {
                        text: "",
                        rounded: "",
                        disabled: !_setup.valid,
                        loading: _setup.loading,
                        color: "primary",
                      },
                      on: {
                        click: function ($event) {
                          return _setup.process($event)
                        },
                      },
                    },
                    [_vm._v("\n                    Save\n                ")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }